import {
  CARGO_RATIO_LABELS,
  getCargoRatioKey,
} from '../../../TenderOpening/components/Detail/HpsParcel/lpg/utils';

export const getRowKey = row => {
  const base =
    row.quantityInformationDetailId ??
    `${row.id}-${row.quantityIncotermId ?? row.quantityInformationId}`;

  if (row.quantityInformationCargoRatioId) {
    return `${base}-${row.quantityInformationCargoRatioId}`;
  }
  if (
    row.cargoRatio !== null &&
    row.cargoRatio !== undefined &&
    row.cargoRatio !== ''
  ) {
    return `${base}-cr-${row.cargoRatio}`;
  }
  if (row.incotermLocationId) {
    return `${base}-loc-${row.incotermLocationId}`;
  }
  return String(base);
};

export const collectOriginalCargoRatios = (items, rowData) => {
  const seen = new Set();
  return items.reduce((ratios, item) => {
    const sameIncoterm =
      String(item.quantityIncotermId ?? '') ===
      String(rowData.quantityIncotermId ?? '');
    const sameInformation =
      String(item.quantityInformationId ?? '') ===
      String(rowData.quantityInformationId ?? '');
    if (!sameIncoterm && !sameInformation) return ratios;
    if (
      item.cargoRatio === null ||
      item.cargoRatio === undefined ||
      item.cargoRatio === ''
    ) {
      return ratios;
    }

    const ratioKey = getCargoRatioKey(item.cargoRatio);
    if (seen.has(ratioKey)) return ratios;
    seen.add(ratioKey);
    const ratioId = Number(ratioKey);
    ratios.push({
      id: Number.isFinite(ratioId) ? ratioId : item.cargoRatio,
      label:
        item.cargoRatioLabel ||
        CARGO_RATIO_LABELS[ratioId - 1] ||
        String(item.cargoRatio),
    });
    return ratios;
  }, []);
};
